import { v4 as uuid } from 'uuid';
import { Logger } from "one-logger";

export const enum LogLevel {
    INFO = 10,
    WARN = 20,
    ERROR = 30,
    DEBUG = 40,
}

export const LogLevelMap: {
    [indexer: string]: LogLevel,
} = {
    'INFO': LogLevel.INFO,
    'WARN': LogLevel.WARN,
    'ERROR': LogLevel.ERROR,
    'DEBUG': LogLevel.DEBUG,
};

export type Format = (
    key: string, level: string, title: string, description: string, context?: any,
) => string;

export const defaultFormat: Format = (
    key: string, level: string, title: string, description: string, context?: any,
) => {
    const ts = (new Date()).toISOString();
    const content = (context) ?
        `[${ts},${level}][${key}]${title}, ${description}, ${JSON.stringify(context)}` :
        `[${ts},${level}][${key}]${title}, ${description}`;
    return content;
};

export class Log {
    private key: string;
    private format: Format;
    private level: LogLevel;
    private loggers: Logger[];

    constructor(
        key: string = uuid(),
        loggers: Logger[] = [],
        level: LogLevel = LogLevel.ERROR,
        format: Format = defaultFormat,
    ) {
        this.key = key;
        this.loggers = loggers;
        this.level = level;
        this.format = format;
    }

    add(logger: Logger) {
        this.loggers.push(logger);
    }

    setlevel(level:LogLevel) {
        this.level=level;
    }

    log(
        key: string,
        level: string,
        title: string,
        description: string,
        context?: any,
    ) {
        const { format, loggers } = this;
        const content = format(
            key, level, title, description, context,
        );

        for (const logger of loggers) {
            logger.log(content);
        }
    }

    debug(title: string, description: string, context?: any): void {
        const { key, level } = this;
        if (level >= LogLevel.DEBUG) {
            this.log(
                key, 'DEBUG', title, description, context,
            );
        }
    }

    error(title: string, description: string, context?: any): void {
        const { key, level } = this;
        if (level >= LogLevel.ERROR) {
            this.log(
                key, 'ERROR', title, description, context,
            );
        }
    }

    warn(title: string, description: string, context?: any): void {
        const { key, level } = this;
        if (level >= LogLevel.WARN) {
            this.log(
                key, 'WARN', title, description, context,
            );
        }
    }

    info(title: string, description: string, context?: any): void {
        const { key, level } = this;
        if (level >= LogLevel.INFO) {
            this.log(
                key, 'INFO', title, description, context,
            );
        }
    }
}
